import notificationMiddleware from 'app/middleware/notification';
import taskSocketMiddleware from 'app/middleware/taskSocket';
import thunkMiddleware from 'app/middleware/thunk';
import websocketMiddleware from 'app/middleware/websocket';
import checklistReducer from 'app/store/checklist';
import driverReducer from 'app/store/driver';
import geofenceReducer from 'app/store/geofence';
import issueReducer from 'app/store/issue';
import mapReducer from 'app/store/map';
import notificationReducer from 'app/store/notification';
import reportReducer from 'app/store/report';
import sessionReducer from 'app/store/session';
import settingsReducer from 'app/store/settings';
import taskReducer from 'app/store/task';
import tokenReducer from 'app/store/token';
import trailerReducer from 'app/store/trailer';
import transportReducer from 'app/store/transport';
import useReducer from 'app/store/user';
import websocketReducer from 'app/store/websocket';
import { applyMiddleware, combineReducers, createStore } from 'redux';
import retransmissionPrefixReducer from './retransmission-prefix';
import retransmissionStatusReducer from './retransmission-status';
// Комбинируем различные функции усадки в одну функцию для объекта хранилища.
const combineReducer = combineReducers({
    driver: driverReducer,
    geofence: geofenceReducer,
    map: mapReducer,
    report: reportReducer,
    issue: issueReducer,
    session: sessionReducer,
    transport: transportReducer,
    trailer: trailerReducer,
    user: useReducer,
    websocket: websocketReducer,
    token: tokenReducer,
    checklist: checklistReducer,
    notification: notificationReducer,
    settings: settingsReducer,
    retransmissionPrefix: retransmissionPrefixReducer,
    retransmissionStatus: retransmissionStatusReducer,
    task: taskReducer,
});
// Вернуть исходное состояние в ответ на запрос.
const rootReducer = (state, action) => {
    switch (action.type) {
        case 'SESSION_DELETE':
            return combineReducer(undefined, action);
        default:
            return combineReducer(state, action);
    }
};
// Создает хранилище Redux, в котором хранится полное дерево состояний вашего приложения.
export const store = createStore(rootReducer, 
// Объедините несколько промежуточных программ с помощью
// каждое промежуточное ПО не связано с остальными..
applyMiddleware(...[notificationMiddleware(), thunkMiddleware(), websocketMiddleware(), taskSocketMiddleware()]));
export default store;
